import { jsx } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import PaymentDonutChart from "../PaymentDonutChart/PaymentDonutChart.esm.js";
import { useLastValidPayemntValues, calculateMonthlyMIP, calculateMonthlyPMI } from "./VALoanCalculator.utils.esm.js";
function VALoanCalculatorDonutChart({
  isFHAEnabled,
  isMortgageComponent
}) {
  const form = useFormContext();
  const lastValidValues = useLastValidPayemntValues(form);
  const chartDataProps = {
    monthlyPayment: lastValidValues.calculations.monthlyPayment,
    monthlyPI: lastValidValues.calculations.monthlyPI,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyPropertyTax : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyHomeownersInsurance : 0,
    monthlyPMI: isMortgageComponent && lastValidValues.fields.includePMI ? calculateMonthlyPMI(lastValidValues.fields.homePrice, lastValidValues.fields.downPayment, lastValidValues.loanProgram) : 0,
    monthlyHOA: lastValidValues.calculations.monthlyHOA,
    monthlyMIP: isFHAEnabled && lastValidValues.fields.includeMIP ? calculateMonthlyMIP(lastValidValues.fields.homePrice - lastValidValues.fields.downPayment, lastValidValues.fields.homePrice, lastValidValues.fields.loanProgram) : 0,
    isFHAEnabled
  };
  return /* @__PURE__ */ jsx(PaymentDonutChart, { ...chartDataProps });
}
export {
  VALoanCalculatorDonutChart as default
};
